import { ConstituentLevelConversion } from "./constituentLevelConversion.model";

export class ConstituentLevelConversionData {
    series_data: ConstituentLevelConversion[];
    show_student_conversions_tile: boolean;
    constructor() {
        this.series_data = [];
        this.show_student_conversions_tile = true;
    }

}

